import { useState } from "react";
import {FootballTournamentManager} from "../../../../commons/models/football/football-tournament-manager";
import {User} from "../../../../commons/models/user";
import {Colors} from "../../../../commons/types/core-types";
import IconPersonAdd from "../../../../commons/components/icons/person-add";
import IconPersonDelete from "../../../../commons/components/icons/person-delete";

type DialogMode = "add" | "remove" | undefined;

interface DialogInfo {
    title: string;
    message: string;
    buttonLabel: string;
    icon: React.ReactNode;
    iconColor: Colors;
}

const defaultDialogInfo: DialogInfo = {
    title: "Add Manager To Tournament",
    message: "",
    buttonLabel: "Save",
    icon: <IconPersonAdd/>,
    iconColor: "info",
};

export function useTournamentManagerDialogInfo() {
    const [dialogInfo, setDialogInfo] = useState<DialogInfo>(defaultDialogInfo);

    const updateDialogInfo = (
        user: User | FootballTournamentManager,
        mode: DialogMode
    ) => {
        if (!user || !mode) return;

        const fullName = user.fullName;

        if (mode === "add") {
            setDialogInfo({
                title: "Add Manager To Tournament",
                message: `Do you want to add "<strong>${fullName}</strong>" to the tournament as manager?`,
                buttonLabel: "Save",
                icon: <IconPersonAdd/>,
                iconColor: "info",
            });
        } else {
            setDialogInfo({
                title: "Want To Remove This Manager?",
                message: `Do you want to remove "<strong>${fullName}</strong>" from the tournament manager? Once you remove the manager, the action cannot be undone.`,
                buttonLabel: "Remove",
                icon: <IconPersonDelete/>,
                iconColor: "danger",
            });
        }
    };

    const resetDialogInfo = () => setDialogInfo(defaultDialogInfo);

    return {
        dialogInfo,
        updateDialogInfo,
        resetDialogInfo,
    };
}
